<template>
    <div class="inventory-page">

        <!-- 日历主体 -->
        <div class="calendar-container">
            <!-- 日历头部 -->
            <div class="calendar-header">
                <div class="month-selector">
                    <el-button icon="el-icon-arrow-left" @click="changeMonth(-1)"></el-button>
                    <span class="current-month">{{ currentYear }}年{{ currentMonth }}月</span>
                    <el-button icon="el-icon-arrow-right" @click="changeMonth(1)"></el-button>
                </div>
                <div class="actions">
                    <el-button type="primary" @click="openSingleDayDialog">设置单日库存</el-button>
                    <el-button type="primary" @click="openBatchDialog">批量设置库存</el-button>
                </div>
            </div>

            <!-- 星期表头 -->
            <div class="calendar-week">
                <div class="week-item" v-for="day in weekDays" :key="day">{{ day }}</div>
            </div>

            <!-- 日历格子 -->
            <div class="calendar-grid">
                <div v-for="(day, index) in calendarDays" :key="index" class="day-cell" :class="{
                    'other-month': day.otherMonth,
                    'selected': selectedDate === day.date,
                    'disabled': isBeforeToday(day.date)
                }" @click="selectDate(day)">
                    <div class="day-number">{{ day.dayNumber }}</div>
                    <div class="inventory-info" v-if="!day.otherMonth">
                        <div class="sold">已售：{{ day.sold }}</div>
                        <div class="available">可售：{{ day.available }}</div>
                    </div>
                    <el-popover v-if="!day.otherMonth" placement="right" width="200" trigger="hover" :close-delay="1"
                        :open-delay="1" popper-class="inventory-popover">
                        <div class="inventory-detail">
                            <div class="detail-title">库存详情</div>
                            <div class="detail-item">
                                <span class="label">上架：</span>
                                <span class="value">{{ day.total }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="label">已售：</span>
                                <span class="value">{{ day.sold }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="label">可售：</span>
                                <span class="value">{{ day.available }}</span>
                                <el-link v-if="!isBeforeToday(day.date)" type="primary" class="adjust-link"
                                    @click="adjustInventory(day)">调整</el-link>
                            </div>
                        </div>
                        <div slot="reference" class="trigger-area"></div>
                    </el-popover>
                </div>
            </div>
        </div>

        <!-- 设置单日库存弹窗 -->
        <el-dialog title="设置单日库存" :visible.sync="singleDayDialogVisible" width="400px">
            <el-form :model="singleDayForm" label-width="80px" :rules="singleDayRules" ref="singleDayForm">
                <el-form-item label="日期选择" prop="date" required>
                    <el-date-picker v-model="singleDayForm.date" type="date" placeholder="选择日期"
                        :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
                <el-form-item label="当日可售" prop="available" required>
                    <el-input v-model="singleDayForm.available" v-input-filter="{ min: 0, max: 999999, precision: 0 }">
                        <template slot="append">件</template>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="singleDayDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveSingleDayInventory">保存</el-button>
            </div>
        </el-dialog>

        <!-- 批量设置库存弹窗 -->
        <el-dialog title="批量设置库存" :visible.sync="batchDialogVisible" width="500px" custom-class="batch-dialog">
            <el-form :model="batchForm" label-width="80px" size="small" :rules="batchRules" ref="batchForm">
                <el-form-item label="日期范围" prop="dateRange">
                    <el-date-picker v-model="batchForm.dateRange" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" style="width: 100%" value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
                <el-form-item label="每日可售" prop="available">
                    <el-input v-model="batchForm.available"
                        v-input-filter="{ min: 0, max: 999999, precision: 0 }"></el-input>
                    <template slot="append">件</template>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="batchDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveBatchInventory">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'inventory',
    data() {
        return {
            id: this.$route.query.id || null,
            weekDays: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth() + 1,
            selectedDate: '',
            calendarDays: [],

            // 单日设置
            singleDayDialogVisible: false,
            singleDayForm: {
                date: '',
                available: ''
            },
            singleDayRules: {
                date: [
                    { required: true, message: '请选择日期', trigger: ['change', 'blur'] }
                ],
                available: [
                    { required: true, message: '请输入可售数量', trigger: ['blur', 'change'] }
                ]
            },

            // 批量设置
            batchDialogVisible: false,
            batchForm: {
                dateRange: [],
                available: ''
            },
            batchRules: {
                dateRange: [
                    { required: true, message: '请选择日期范围', trigger: ['change', 'blur'] }
                ],
                available: [
                    { required: true, message: '请输入可售数量', trigger: ['blur', 'change'] }
                ]
            },


            // 库存数据
            inventoryData: {},

            // 添加禁用今天之前和90天之后的日期的属性
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < new Date().setHours(0, 0, 0, 0) || time.getTime() > new Date().setDate(new Date().getDate() + 90);
                }
            }
        }
    },
    created() {
        this.initCalendar()
    },
    methods: {
        // 初始化日历数据
        async initCalendar() {
            const year = this.currentYear
            const month = this.currentMonth
            const firstDay = new Date(year, month - 1, 1)
            const lastDay = new Date(year, month, 0)
            let start = new Date(year, month - 1, 1, 0, 0, 0).getTime() / 1000
            let end = new Date(year, month, 0, 23, 59, 59).getTime() / 1000
            let url = `/api/v1/manage/travelGoods/inventory/${this.id}`
            let { data } = await this.$axios.get(url, {
                startTime: start,
                endTime: end
            })

            // 获取当月第一天是周几（0-6，0代表周日）
            let firstDayWeek = firstDay.getDay()
            firstDayWeek = firstDayWeek === 0 ? 7 : firstDayWeek

            // 获取上个月的最后几天
            const prevMonthDays = []
            const prevMonthLastDay = new Date(year, month - 1, 0).getDate()
            for (let i = firstDayWeek - 1; i > 0; i--) {
                prevMonthDays.push({
                    date: `${month === 1 ? year - 1 : year}-${month === 1 ? 12 : month - 1}-${prevMonthLastDay - i + 1}`,
                    dayNumber: prevMonthLastDay - i + 1,
                    otherMonth: true
                })
            }

            // 获取当月的天数
            const currentMonthDays = []
            for (let i = 1; i <= lastDay.getDate(); i++) {
                let cDay = data.find(item => item.saleDate === new Date(`${year}-${month}-${i} 00:00:00`).getTime() / 1000);
                const date = `${year}-${month}-${i}`
                currentMonthDays.push({
                    date,
                    dayNumber: i,
                    otherMonth: false,
                    total: cDay?.totalQuantity || 0,
                    sold: cDay?.soldQuantity || 0,
                    available: cDay?.remainingQuantity || 0
                })
            }

            // 获取下个月的前几天
            const nextMonthDays = []
            const remainingDays = 42 - prevMonthDays.length - currentMonthDays.length
            for (let i = 1; i <= remainingDays; i++) {
                nextMonthDays.push({
                    date: `${month === 12 ? year + 1 : year}-${month === 12 ? 1 : month + 1}-${i}`,
                    dayNumber: i,
                    otherMonth: true
                })
            }

            this.calendarDays = [...prevMonthDays, ...currentMonthDays, ...nextMonthDays]
        },

        // 切换月份
        changeMonth(offset) {
            const newDate = new Date(this.currentYear, this.currentMonth - 1 + offset)
            this.currentYear = newDate.getFullYear()
            this.currentMonth = newDate.getMonth() + 1
            this.initCalendar()
        },

        // 选择日期
        selectDate(day) {
            if (!day.otherMonth && !this.isBeforeToday(day.date)) {
                this.selectedDate = day.date
                this.singleDayForm.date = day.date
                this.singleDayForm.available = day.available
                this.openSingleDayDialog()
            }
        },

        // 打开单日设置弹窗
        openSingleDayDialog() {
            this.singleDayDialogVisible = true
        },

        // 打开批量设置弹窗
        openBatchDialog() {
            this.batchDialogVisible = true
        },

        // 保存单日库存
        async saveSingleDayInventory() {

            let valid = await this.$refs.singleDayForm.validate()
            if (!valid) {
                return
            }
            // TODO: 调用接口保存单日库存
            let url = `/api/v1/manage/travelGoods/inventory`
            let params = {
                id: this.id,
                saleDateStart: new Date(this.singleDayForm.date).setHours(0, 0, 0, 0) / 1000,
                remainingQuantity: this.singleDayForm.available
            }
            let { code } = await this.$axios.post(url, params)
            if (code === 1) {
                this.$message.success('设置成功')
                this.initCalendar()
                this.singleDayDialogVisible = false
            }
        },

        // 保存批量库存
        async saveBatchInventory() {
            let valid = await this.$refs.batchForm.validate()
            if (!valid) {
                return
            }
            try {
                let url = `/api/v1/manage/travelGoods/inventory`
                let params = {
                    id: this.id,
                    saleDateStart: new Date(this.batchForm.dateRange[0]).setHours(0, 0, 0, 0) / 1000,
                    saleDateEnd: new Date(this.batchForm.dateRange[1]).setHours(23, 59, 59, 0) / 1000,
                    remainingQuantity: this.batchForm.available
                }
                let { code } = await this.$axios.post(url, params)
                if (code === 1) {
                    this.$message.success('设置成功')
                    this.initCalendar()
                    this.batchDialogVisible = false
                }

            } catch (error) {
                this.$message.error('设置失败')
            }
        },

        // 调整库存
        adjustInventory(day) {
            this.selectedDate = day.date;
            this.singleDayForm.date = day.date;
            this.singleDayForm.available = day.available;
            this.openSingleDayDialog();
        },

        // 添加判断日期是否在今天之前的方法
        isBeforeToday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const compareDate = new Date(date);
            compareDate.setHours(0, 0, 0, 0);
            return compareDate < today;
        },
    }
}
</script>

<style lang="less" scoped>
.inventory-page {

    .breadcrumb {
        margin-bottom: 16px;

        .separator {
            margin: 0 8px;
            color: #606266;
        }
    }

    .calendar-container {
        background: #fff;
        border-radius: 8px;
        padding: 20px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

        .calendar-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            padding-bottom: 16px;
            border-bottom: 1px solid #ebeef5;

            .month-selector {
                display: flex;
                align-items: center;
                gap: 12px;

                .el-button {
                    border-radius: 6px;
                }

                .current-month {
                    font-size: 18px;
                    font-weight: 600;
                    min-width: 120px;
                    text-align: center;
                    color: #303133;
                }
            }

            .actions {
                display: flex;
                gap: 12px;
                
                .el-button {
                    border-radius: 6px;
                }
            }
        }

        .calendar-week {
            display: grid;
            grid-template-columns: repeat(7, 1fr);
            text-align: center;
            border-bottom: 1px solid #EBEEF5;
            margin-bottom: 12px;
            background: #f5f7fa;
            border-radius: 6px 6px 0 0;

            .week-item {
                padding: 12px 0;
                color: #606266;
                font-weight: 500;
                font-size: 14px;
            }
        }

        .calendar-grid {
            display: grid;
            grid-template-columns: repeat(7, 1fr);
            gap: 1px;
            background: #EBEEF5;
            border-radius: 0 0 6px 6px;
            overflow: hidden;

            .day-cell {
                background: #fff;
                min-height: 80px;
                padding: 12px;
                cursor: pointer;
                position: relative;
                transition: all 0.2s ease;

                &:hover {
                    background: #f0f7ff;
                }

                &.other-month {
                    color: #C0C4CC;
                    cursor: not-allowed;
                    background: #fafbfc;

                    .inventory-info {
                        display: none;
                    }
                }

                &.selected {
                    background: #f0f7ff;
                    box-shadow: inset 0 0 0 2px #2B77FF;
                }

                &.disabled {
                    background: #f5f5f5;
                    cursor: not-allowed;
                    opacity: 0.6;

                    &:hover {
                        background: #f5f5f5;
                    }
                }

                .day-number {
                    font-size: 16px;
                    font-weight: 600;
                    margin-bottom: 8px;
                    color: #303133;
                }

                .inventory-info {
                    font-size: 12px;
                    color: #606266;
                    line-height: 1.6;

                    .sold {
                        margin-bottom: 4px;
                        color: #909399;
                    }
                    
                    .available {
                        color: #67C23A;
                        font-weight: 500;
                    }
                }

                .trigger-area {
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    z-index: 1;
                }
            }
        }
    }
    
    // 弹窗样式
    :deep(.el-dialog) {
        border-radius: 8px;
        
        .el-dialog__header {
            padding: 16px 20px;
            border-bottom: 1px solid #ebeef5;
            
            .el-dialog__title {
                font-size: 16px;
                font-weight: 600;
                color: #303133;
            }
        }
        
        .el-dialog__body {
            padding: 20px;
        }
        
        .el-dialog__footer {
            padding: 12px 20px;
            border-top: 1px solid #ebeef5;
            
            .el-button {
                border-radius: 6px;
            }
        }
        
        .el-form-item__label {
            font-weight: 500;
        }
        
        .el-input__inner {
            border-radius: 6px;
        }
    }
}

.batch-dialog {
    :deep(.el-dialog__body) {
        padding: 20px;
    }

    .unit-text {
        margin-left: 8px;
        color: #606266;
    }

    .el-form-item {
        margin-bottom: 20px;
    }

    .dialog-footer {
        text-align: right;
    }
}

:deep(.inventory-popover) {
    border-radius: 8px;
    
    .inventory-detail {
        .detail-title {
            font-size: 15px;
            font-weight: 600;
            margin-bottom: 12px;
            color: #303133;
            padding-bottom: 8px;
            border-bottom: 1px solid #ebeef5;
        }

        .detail-item {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            font-size: 13px;

            .label {
                color: #909399;
                width: 45px;
            }

            .value {
                color: #303133;
                font-weight: 500;
            }

            .adjust-link {
                margin-left: auto;
                font-size: 13px;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}
</style>
